import React, { useEffect, useState } from "react";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import i18n from "utils/i18n";
import _ from "lodash";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedBlock from "components/atoms/ThemedBlock";
import LoadingComponent from "components/atoms/Loading";
import { listArrow } from "styles/list";
import { constantsActive, constantsGraphql } from "utils/constants/constants";
import { dataConstants } from "services/redux/data/constants";
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import FetchCachedJobtitle from 'utils/fetch/cached/FetchCachedJobtitle'
import { AppRoutes } from 'navigations/app-routes'
import HelperManagementRights from "utils/helper-management-rights";
import { managementRightsConstants } from "utils/constants/management-right-constants";
import { useShowHamburger } from 'utils/helper-device'
import ListItem from 'components/atoms/ListItem'

const ManagementJobtitlesScene = () => {
	
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	const showHamburger = useShowHamburger();
	
	const _jobtitles = useSelector( state => {
		return state.data[dataConstants.JOBTITLES];
	} );
	
	const [ loading, setLoading ] = useState( true )
	const [ search, setSearch ] = useState( '' )
	
	const fetchJobtitles = () => {
		FetchCachedJobtitle.fetchAll( {
			variables: {
				active: constantsGraphql.YES_NO,
			},
			callbackSuccess: setLoading.bind( this, false ),
			callbackError: setLoading.bind( this, false ),
		} );
	}
	
	const openJobtitle = ( jobtitle ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_JOBTITLES_JOBTITLES_VIEW, {
			jobtitleGuid: jobtitle.guid,
		} );
	}
	
	const createJobtitle = () => {
		openJobtitle( {} );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ item.name }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openJobtitle }
			/>
		)
	}
	
	const searchChanged = ( value ) => {
		setSearch( value?.toLowerCase() ?? '' )
	}

	useEffect( () => {
		return fetchJobtitles();
	}, [ isFocused ] )
	
	const filters = _.size( search ) > 2 ? [ { field: 'name', kind: 'contains', value: search } ] : null;
	
	let content = <LoadingComponent />
	if( !loading ) {
		const header = (
			<ManagementHeader
				inputs={[
					{
						placeholder: i18n.t( 'management:pages.jobtitles.jobtitles.input_search'),
						onChangeText: _.debounce( searchChanged.bind( this ), 400 ),
					}
				]}
				addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.JOBTITLES ) ? {
					onPress: createJobtitle.bind( this )
				} : null }
			/>
		);
		
		content = (
			<ManagementGroupedThemeList
				header={ header }
				items={ _jobtitles }
				renderItem={ renderItem }
				groupByKey={ 'active' }
				filters={ filters }
				groupByValues={ [
					constantsActive.YES,
					constantsActive.NO
				]}
			/>
		)
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>

			<ThemedLayout
				title={ i18n.t('management:pages.jobtitles.jobtitles.title') }
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<ThemedBlock transparent />
				
				{ content }
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementJobtitlesScene
